import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './styles';

import { END_ONLY_REPORT_PERIODS } from './index';
import DateInput from 'app/src/elements/DateInput';

const BalanceSheet = () => {
  const [endOn, setEndOn] = useState(
    DateTime.now().minus({ months: 1 }).endOf('month').toISODate()
  );

  const [reportPeriod, setReportPeriod] = useState('YTD');

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'balance-sheet',
      params: { 'end-on': endOn, 'report-period': reportPeriod },
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Balance Sheet</Text>
      <Text style={styles.label}>End On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <Text style={styles.label}>Report Period(s):</Text>
      <select
        style={styles.select}
        onChange={(e) => setReportPeriod(e.target.value)}
      >
        {END_ONLY_REPORT_PERIODS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default BalanceSheet;
